import React, { createContext, useCallback, useContext, useMemo, useRef } from 'react'

type FlushFn = () => Promise<void>

interface OrderFormSaveContextValue {
  registerFlush: (fn: FlushFn | null) => void
  flushPendingSave: () => Promise<void>
}

const OrderFormSaveContext = createContext<OrderFormSaveContextValue | null>(null)

export const OrderFormSaveProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const flushRef = useRef<FlushFn | null>(null)

  const registerFlush = useCallback((fn: FlushFn | null) => {
    flushRef.current = fn
  }, [])

  const flushPendingSave = useCallback(async () => {
    if (flushRef.current) {
      await flushRef.current()
    }
  }, [])

  const value = useMemo(
    () => ({
      registerFlush,
      flushPendingSave,
    }),
    [registerFlush, flushPendingSave],
  )

  return <OrderFormSaveContext.Provider value={value}>{children}</OrderFormSaveContext.Provider>
}

export const useOrderFormSave = (): OrderFormSaveContextValue => {
  const ctx = useContext(OrderFormSaveContext)
  if (!ctx) {
    return {
      registerFlush: () => undefined,
      flushPendingSave: async () => undefined,
    }
  }
  return ctx
}
